import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Select from "react-select";
import { Input } from "../../../components/Input";
import ModalComponent from "../../../components/ModalComponent";
import * as HTTPServices from "../../../api/HTTPServices";

import moment from "moment";
import classes from "./index.module.scss";

function SetCalendarModal({ open, handleClose, updateData }) {
  const { register, handleSubmit } = useForm();
  const [type, setType] = useState(1);
  const [selectedDay, setSelectedDay] = useState();
  const [choosenUntilDate, setChoosenUntilDate] = useState();
  const [selectedDayOfWeek, setSelectedDayOfWeek] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [selectedcapacity, setSelectedCapacity] = useState("");
  const [selectedMonth, setSelectedMonth] = useState();

  const onSubmit = (data) => {
    console.log(`data`, data);
    const params = new URLSearchParams();
    params.append("day", selectedDay.value);
    params.append("month", selectedMonth.value);
    params.append("sum_date", choosenUntilDate.value);
    params.append("capacity", selectedcapacity.value);
    params.append("time", JSON.stringify(selectedTime));
    params.append("date_time", JSON.stringify(selectedDayOfWeek));
    params.append("price", data.price);
    // params.append("price_off", PriceOff);
    // params.append("dollar_price", dollar_price);
    // params.append("dollar_priceـoff", dollar_priceـoff);
    // params.append("partner_price", partner_price);
    params.append("type", type);

    const RequestService = HTTPServices.postMethod("calender", params, "true");
    RequestService.then(function (response) {
      if (response) {
        console.log(`response`, response);
        handleClose();
        updateData();
      }
    }).catch(function (error) {});
  };
  let dayList = [];
  let monthList = [];
  let untilDate = [];
  let weekArray = moment.weekdays();
  let timeList = [];
  let capacity = [];

  for (let i = 1; i <= 31; i++) {
    dayList.push({ value: parseInt(i), label: parseInt(i) });
  }

  for (let i = 1; i <= 12; i++) {
    monthList.push({
      value: parseInt(i),
      label: moment().month(i).format("MMMM"),
    });
  }

  for (let d = 1; d <= 30; d++) {
    untilDate.push({ value: d, label: d + " day " });
  }

  for (let e = 2; e <= 12; e++) {
    untilDate.push({ value: e * 30, label: e + " month " });
  }

  timeList.push({ value: 0, label: "00 till 1" });

  for (let t = 1; t <= 23; t++) {
    let add_time = t + 1;
    timeList.push({
      value: t,
      label: "" + t + " till " + add_time,
    });
  }

  for (let i = 1; i <= 10; i++) {
    capacity.push({ value: parseInt(i), label: parseInt(i) });
  }

  const handleChangeType = (event) => {
    let value = event.target.value;
    setType(Number(value));
  };

  const handleChangeDay = (selectedDay) => {
    // let choosenDay = moment().day(selectedDay.value).format("dddd");
    setSelectedDay({ value: selectedDay.value, label: selectedDay.value });
  };

  const handleChangeMonth = (selectedMonth) => {
    setSelectedMonth({
      value: selectedMonth.value,
      label: moment().month(selectedMonth.value).format("MMMM"),
    });
  };
  const handleChangeUntilDate = (untilDate) => {
    setChoosenUntilDate({
      value: untilDate.value,
      label: untilDate.label,
    });
  };

  const handleChangeDayOfWeek = (event) => {
    const key = +event.target.value;
    //The value of the checkbox. The DOM API casts this to a string.
    if (event.target.checked) {
      switch (key) {
        case key:
          setSelectedDayOfWeek([...selectedDayOfWeek, weekArray[key]]);
          break;

        default:
          break;
      }
    } else {
      switch (key) {
        case key:
          let arr = selectedDayOfWeek.filter((obj) => obj !== weekArray[key]);
          setSelectedDayOfWeek(arr);
          break;
        default:
          break;
      }
    }
  };

  const handleChangeTime = (selectTime) => {
    const key = +selectTime.target.value;
    if (selectTime.target.checked) {
      for (let i = 0; i < 24; i++) {
        switch (key) {
          case i:
            setSelectedTime([...selectedTime, timeList[i]]);
            break;

          default:
            break;
        }
      }
    } else {
      for (let i = 0; i < 24; i++) {
        switch (key) {
          case i:
            let arr = selectedTime.filter((obj) => obj.value !== key);
            setSelectedTime(arr);

            break;

          default:
            break;
        }
      }
    }
  };

  const handleCapacity = (event) => {
    const key = +event.target.value;
    //The value of the checkbox. The DOM API casts this to a string.
    setSelectedCapacity(capacity[key - 1]);
  };

  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      closeBtn={handleClose}
      confirmBtn={true}
      handleOk={handleSubmit(onSubmit)}
      title="set data table"
    >
      <div className={classes.mainContainer}>
        <p>
          To register the visit schedule, please enter the information in the
          following section.
        </p>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormControl style={{ width: "100%" }}>
            <h4>choose visit type</h4>

            <RadioGroup
              aria-label="gender"
              name="vtype"
              value={type}
              onChange={handleChangeType}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <FormControlLabel
                value={1}
                control={<Radio />}
                label="ordinary"
              />
              <FormControlLabel value={2} control={<Radio />} label="express" />
              <FormControlLabel value={3} control={<Radio />} label="offline" />
            </RadioGroup>
          </FormControl>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <h4>visit date start at</h4>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "40%" }}>
              <Select
                value={selectedDay}
                onChange={handleChangeDay}
                // {...register("selectedDay", { required: true })}
                options={dayList}
                placeholder="day"
                noOptionsMessage={() => "nothing found"}
              />
            </div>
            <div style={{ width: "40%" }}>
              <Select
                value={selectedMonth}
                onChange={handleChangeMonth}
                options={monthList}
                placeholder="month"
                noOptionsMessage={() => "nothing found"}
              />
            </div>
          </div>
          <div>
            <h4>untile</h4>
            <Select
              value={choosenUntilDate}
              onChange={handleChangeUntilDate}
              options={untilDate}
              placeholder="month"
              noOptionsMessage={() => "nothing found"}
            />
          </div>
          <div>
            <h4>choose dates you want to visit</h4>
            <div style={{ border: "1px solid gray", margin: 5, padding: 5 }}>
              <Grid container spacing={3}>
                {weekArray.map((day, index) => {
                  return (
                    <Grid key={index} item xs={4} sm={3}>
                      <Grid>
                        <label htmlFor="date">{day}</label>
                      </Grid>
                      <Grid>
                        <Checkbox
                          onChange={handleChangeDayOfWeek}
                          value={index}
                        />
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          </div>
          <div>
            <h4>choose hours you want to visit</h4>
            <div style={{ border: "1px solid gray", margin: 5, padding: 5 }}>
              <Grid container spacing={3}>
                {timeList.map((time, index) => {
                  return (
                    <Grid key={index} item xs={4} sm={3}>
                      <Grid>
                        <label htmlFor="date">{time.label}</label>
                      </Grid>
                      <Grid>
                        <Checkbox
                          onChange={handleChangeTime}
                          value={time.value}
                        />
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
          </div>
          <div>
            <h4>capacity per hours</h4>
            <div style={{ border: "1px solid gray", margin: 5, padding: 5 }}>
              <Grid container spacing={3}>
                <RadioGroup
                  style={{
                    flexDirection: "row",
                  }}
                  value={selectedcapacity || ""}
                >
                  {capacity.map((item, index) => {
                    return (
                      <Grid
                        key={index}
                        item
                        xs={2}
                        sm={2}
                        style={{ textAlign: "center", margin: 5 }}
                      >
                        <Grid>
                          <label htmlFor="capacity">
                            {item.label.toString()}
                          </label>
                        </Grid>
                        <Grid>
                          <Radio
                            key={Math.random()}
                            checked={item.value === selectedcapacity.value}
                            onChange={handleCapacity}
                            value={item.value}
                            name="radio-button-demo"
                          />
                        </Grid>
                      </Grid>
                    );
                  })}
                </RadioGroup>
              </Grid>
            </div>
          </div>
          <div style={{ marginBottom: 10 }}>
            <Input {...register("price")} label="enter visit price" />
          </div>
        </form>
      </div>
    </ModalComponent>
  );
}

export default SetCalendarModal;
